import React, { Component } from "react";
import ReactDOM from "react-dom";

import { connect } from "react-redux";
import { addLanguage, addRegister, addLogin } from "../../actions/AppActions";

import {
  Button,
  Segment,
  Image,
  Dropdown,
  Header,
  Grid,
  Divider,
  Icon,
  Item,
  Form,
  Modal,
  Message
} from "semantic-ui-react";

import API from "../../services/Api";

import Exit from "../../assets/img/Exit.svg";

import { translate } from "react-translate";
import _ from "lodash";

import "./RegisterComponent.css";

const mapStateToProps = state => ({
  app: state.app
});

const mapActionToProps = {
  addLanguage: addLanguage,
  addRegister: addRegister,
  addLogin: addLogin
};

const rightOptions = [
  { key: "4", text: "value_table_particuliers", value: "4", type: "user" },
  { key: "3", text: "value_table_enterprises", value: "3", type: "enterprise" },
  {
    key: "2",
    text: "value_table_prescripteurs",
    value: "2",
    type: "prescripteur"
  }
  // {key: '1', text:'Commerciaux', value:'1'},
  // {key: '0', text:'Administrateur', value:'0'},
];

class ConnectedRegisterComponent extends Component {
  constructor(props) {
    super(props);

    let job = rightOptions.find(({ type }) => type === props.app.userType);
    job = job != null ? job.value : null;

    this.state = {
      email: null,
      password: null,
      name: null,
      country: null,
      postalcode: null,
      type: null,
      oldpass: null,
      newpass: null,
      response: null,
      value: null,
      responseCountry: null,
      countryId: null,
      user_type: 0,
      error_input_email: true,
      error_input_password: true,
      error_input_passwordconfirm: true,
      error_input_name: true,
      error_input_country: true,
      error_input_postal: true,
      warningError: null,
      warningErrorMdp: false,
      warningErrorPostal: false,
      modalOpen: false,

      rightOptions,
      job
    };

    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeJob = this.handleChangeJob.bind(this);
    this.handleChangePostalcode = this.handleChangePostalcode.bind(this);

    // this.handleChangeLang = this.handleChangeLang.bind(this);
    // this.handleChangeNewpass = this.handleChangeNewpass.bind(this);
    // this.handleChangeOldpass = this.handleChangeOldpass.bind(this);
    // this.handleChangeCountry = this.handleChangeCountry.bind(this);

    // this.setLang = this.setLang.bind(this);

    this.handleSubmitRegister = this.handleSubmitRegister.bind(this);

    // this.handleSubmitCountry = this.handleSubmitCountry.bind(this);

    // this.handleClickGender = this.handleClickGender.bind(this);
    // this.handleClickPro = this.handleClickPro.bind(this)

    // this.handleChange = this.handleChange.bind(this);
    this.addRegister = this.addRegister.bind(this);
    // this.handleCloseRenameSecond = this.handleCloseRenameSecond.bind(this)

    // this.handleChangePasswordConfirm = this.handleChangePasswordConfirm.bind(this)
    this.openLogin = this.openLogin.bind(this);
  }

  componentDidMount() {
    let { t } = this.props;
    var rightOptionsCopy = _.clone(rightOptions);
    rightOptionsCopy = _.map(rightOptionsCopy, x => {
      return {
        ...x,
        text: t(x.text)
      };
    });
    this.setState({
      rightOptions: rightOptionsCopy
    });
  }

  // handleChange(e, data) {
  //     let countryId
  //     Object.entries(this.state.responseCountry).map((key, mainindex) => {
  //         if (key[1].text === data.value) {
  //             countryId = key[1].key
  //         }
  //     })
  //     this.setState({
  //         countryId: countryId,
  //         error_input_country: false
  //     })
  // }

  reset() {
    this.setState({
      value: null
    });
  }

  setValue(e, data) {
    this.setState({
      value: data.value
    });
    this.setLang(this.state.value);
  }

  // setLang(value) {
  //     this.props.addLanguage(value)
  // }

  addRegister() {
    this.setState({
      warningError: null,
      response: null
    });
    this.props.addRegister(false);
  }

  handleSubmitRegister(event) {
    event.preventDefault();

    let check = false;

    const { t } = this.props;

    if (
      !this.state.error_input_country &&
      !this.state.error_input_email &&
      !this.state.error_input_postal &&
      !this.state.error_input_name
    ) {
      if (
        !this.state.error_input_password &&
        !this.state.error_input_passwordconfirm &&
        this.state.password === this.state.password_confirm
      ) {
        var registerData = {
          email: this.state.email,
          password: this.state.password,
          name: this.state.name,
          gender: this.state.gender,
          country: this.state.countryId,
          postalcode: this.state.postalcode,
          lang: this.props.app.lang,
          type: "INT",
          user_type: this.state.user_type
        };
        // API.register(this.props.token, registerData).then((res) => {
        //     let modal = false
        //     let response = res.data;
        //     if (response.code === 200) {
        //         modal = true
        //     }
        //     this.setState({
        //         warningErrorMdp: false,
        //         warningErrorPostal: false,
        //         warningError: null,
        //         modalOpen: modal,
        //         response: response
        //     })
        // });
      } else {
        this.setState({
          warningErrorMdp: true,
          response: null,
          warningError: t("error_same_password")
        });
      }
    } else {
      this.setState({
        response: null,
        warningError: t("error_multiple")
      });
    }
  }

  sendUser() {
    if (
      this.state.name == null ||
      this.state.name.length === 0 ||
      this.state.email == null ||
      this.state.email.length === 0 ||
      this.state.password == null ||
      this.state.password.length === 0 ||
      this.state.postalcode == null ||
      this.state.name.postalcode === 0
    ) {
      this.setState({
        error: true
      });

      return;
    }

    var form = new FormData();
    form.append("name", this.state.name);
    form.append("username", this.state.name);
    form.append("surname", this.state.email);
    form.append("email", this.state.email);
    form.append("password", this.state.password);
    form.append("job", Number(this.state.job) || 0);
    form.append("postalcode", this.state.postalcode);
    API.addClient(form).then(() => {
      this.setState({
        loading: false
      });
      this.props.login(this.state.email, this.state.password);
    });
  }

  handleSubmitCountry() {
    var pwd = this;

    // API.getCountries(this.props.app.token, {lang: this.props.app.lang}).then((res) => {
    //     var response = res.data;
    //     let tmp = []
    //     Object.entries(response).map((key, mainindex) => {
    //         if (key[0] === 'countries') {
    //             Object.entries(key[1]).map((key, mainindex) => {
    //                 var countries = {}
    //                 countries.key = key[1].pkuid
    //                 countries.text = key[1].name
    //                 countries.value = key[1].name
    //                 tmp.push(countries)
    //             })
    //         }
    //     })
    //     pwd.setState({
    //         responseCountry: tmp
    //     })
    // }, (err) => {
    //     pwd.setState({
    //         error: err.error
    //     })
    // });
  }

  // handleClickGender(e) {
  //     e.preventDefault();

  //     let value = e.target.value != undefined ? e.target.value : e.target.getAttribute('value');

  //     this.setState({
  //         gender: value,
  //     })
  // }

  handleClickPro(e) {
    e.preventDefault();

    let value =
      e.target.value != undefined
        ? e.target.value
        : e.target.getAttribute("value");

    this.setState({
      user_type: value
    });
  }

  handleChangeEmail(event) {

    if (
      event.target.value === "" ||
      event.target.value === null ||
      event.target.value === undefined
    ) {
      this.setState({
        email: event.target.value,
        error_input_email: true
      });
    } else {
      this.setState({
        email: event.target.value,
        error_input_email: false
      });
    }
  }

  handleChangeName(event) {

    if (
      event.target.value === "" ||
      event.target.value === null ||
      event.target.value === undefined
    ) {
      this.setState({
        name: event.target.value,
        error_input_name: true
      });
    } else {
      this.setState({
        name: event.target.value,
        error_input_name: false
      });
    }
  }

  handleChangeJob(e, data) {
    this.setState({ job: data.value });
  }

  // handleChangeCountry(event) {
  //     this.setState({
  //         lang: event.target.value
  //     });
  // }

  // handleChangeLang(event) {
  //     this.setState({ lang: event.target.value });
  // }

  handleChangePassword(event) {
    if (
      event.target.value === "" ||
      event.target.value === null ||
      event.target.value === undefined
    ) {
      this.setState({
        password: event.target.value,
        error_input_password: true
      });
    } else {
      this.setState({
        password: event.target.value,
        error_input_password: false
      });
    }
  }

  handleChangePostalcode(event) {
    if (
      event.target.value === "" ||
      event.target.value === null ||
      event.target.value === undefined
    ) {
      this.setState({
        postalcode: event.target.value,
        error_input_postal: true
      });
    } else {
      this.setState({
        postalcode: event.target.value,
        error_input_postal: false
      });
    }
  }

  // handleChangeNewpass(event) {
  //     this.setState({ newpass: event.target.value });
  // }

  // handleChangeOldpass(event) {
  //     this.setState({ oldpass: event.target.value });
  // }

  // handleChangePasswordConfirm(e) {
  //     this.setState({
  //         password_confirm: e.target.value,
  //         error_input_passwordconfirm: false
  //     });
  // }

  // handleCloseRenameSecond() {
  //     this.setState({
  //         modalOpen: false
  //     })
  //     this.addRegister()
  // }

  openLogin() {
    this.props.addRegister(false);
    this.props.addLogin(true);
  }

  render() {
    var errorMessageRegister = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "1.2em"
    };

    const { t } = this.props;
    const { value } = this.state;

    return (
      <Modal
        id="registerMain"
        size="mini"
        open={this.props.app.register}
        style={{ width: "390px" }}
        observeChanges="true"
        onClose={this.addRegister}
      >
        <div
          ref={node => {
            this.node = node;
          }}
        >
          <Modal.Content className="windowRegister">
            <Grid textAlign="center" verticalAlign="middle" padded>
              <Grid.Column className="columnRegister">
                <Image
                  onClick={this.addRegister}
                  src={Exit}
                  verticalAlign="middle"
                  floated="right"
                  id="exit"
                />

                <Header as="h2" className="windowRegisterh3">
                  {t("register_title")}
                </Header>
                <br />
                <div class="ui divider" />
                {/* <Divider id="divider" horizontal></Divider> */}
                <Form
                  onSubmit={this.handleSubmitRegister}
                  id="formRegister"
                  error={this.state.error}
                >
                  <h4 className="labelstyling">
                    {t("register_name")}
                    <span className="spanColor">*</span>
                  </h4>
                  <Form.Input
                    type="text"
                    onChange={this.handleChangeName}
                    error={
                      this.state.name == null || this.state.name.length === 0
                    }
                    // placeholder={t('placeholder_name')}
                  />
                  <h4 className="labelstyling">
                    {t("register_email")}
                    <span className="spanColor">*</span>
                  </h4>
                  <Form.Input
                    type="email"
                    onChange={this.handleChangeEmail}
                    fluid
                    error={
                      this.state.email == null || this.state.email.length === 0
                    }
                  />
                  <h4 className="labelstyling">
                    {t("register_password")}
                    <span className="spanColor">*</span>
                  </h4>
                  <Form.Input
                    type="password"
                    onChange={this.handleChangePassword}
                    fluid
                    error={
                      this.state.password == null ||
                      this.state.password.length === 0
                    }
                  />

                  <Grid>
                    {/* <Grid.Row columns={3} style={{paddingBottom:'0'}}>
                                            <Grid.Column verticalAlign='middle' textAlign='left' width={4}  style={{ flexGrow: '1' }}>
                                                <Item.Header as='h5' className="label">{t('gender')}</Item.Header>
                                            </Grid.Column>
                                            <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                                {
                                                    this.state.gender == 1 ? (
                                                        <Button onClick={this.handleClickGender} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff', marginLeft: '20px' }}>
                                                            <Image value={1} src={hommeShapeWhite} /> {t('male')}
                                                        </Button>

                                                    ) : (

                                                            <Button onClick={this.handleClickGender} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)', marginLeft: '20px' }} >
                                                                <Image value={1} src={hommeShapeGrey} /> {t('male')}
                                                            </Button>

                                                        )
                                                }
                                            </Grid.Column>
                                            <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                                {
                                                    this.state.gender == 0 ? (
                                                        <Button onClick={this.handleClickGender} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff' }}>
                                                            <Image value={0} src={femmeShapeWhite} /> {t('female')}
                                                        </Button>

                                                    ) : (

                                                            <Button onClick={this.handleClickGender} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)' }}>
                                                                <Image value={0} src={femmeShapeGrey} />{t('female')}
                                                            </Button>
                                                        )
                                                }
                                            </Grid.Column>
                                        </Grid.Row> */}
                    {/* <Grid.Row columns={3} style={{paddingBottom:'0'}}>
                                            <Grid.Column verticalAlign='middle' textAlign='left' width={4}  style={{ flexGrow: '1' }}>
                                                <Item.Header as='h5' className="label">{t("pro")}</Item.Header>
                                            </Grid.Column>
                                            <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                                {
                                                    this.state.user_type == 0 ? (

                                                        <Button onClick={this.handleClickPro} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff', marginLeft: '20px' }}>
                                                            <Image value={0} src={particulierWhite} /> {t('particulier')}
                                                        </Button>
                                                    ) : (
                                                            <Button onClick={this.handleClickPro} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)', marginLeft: '20px' }}>
                                                                <Image value={0} src={particulierGrey} /> {t('particulier')}
                                                            </Button>

                                                        )
                                                }
                                            </Grid.Column>
                                            <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                                {
                                                    this.state.user_type == 1 ? (
                                                        <Button onClick={this.handleClickPro} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff' }}>
                                                            <Image value={1} src={professionelWhite} /> {t('professional')}
                                                        </Button>

                                                    ) : (

                                                            <Button onClick={this.handleClickPro} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)' }}>
                                                                <Image value={1} src={professionelGrey} /> {t('professional')}
                                                            </Button>
                                                        )
                                                }
                                            </Grid.Column>
                                        </Grid.Row> */}
                    <Grid.Row columns={2} className="rowRegister">
                      <Grid.Column
                        verticalAlign="top"
                        textAlign="left"
                        width={5}
                      >
                        <Item.Header
                          as="h5"
                          className="label"
                          style={{ paddingTop: "10px" }}
                        />
                      </Grid.Column>
                      <Grid.Column width={16}>
                        <h4 className="labelstyling">
                          {t("register_category")}
                          <span className="spanColor">*</span>
                        </h4>

                        <Dropdown
                          fluid
                          selection
                          value={this.state.job}
                          options={this.state.rightOptions || []}
                          onChange={this.handleChangeJob}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  <h4 className="labelstyling">
                    {t("register_postalcode")}
                    <span className="spanColor">*</span>
                  </h4>
                  <Form.Input
                    id="codePostalRegister"
                    selection
                    onChange={this.handleChangePostalcode}
                    fluid
                    error={
                      this.state.postalcode == null ||
                      this.state.postalcode.length === 0
                    }
                  />

                  {/* {
                                        this.state.warningError ? (
                                            <Grid.Column style={{ paddingBottom: '15px' }} >
                                                <Segment inverted color='red' tertiary style={errorMessageRegister}>
                                                    <Icon name={"remove circle"} />{this.state.warningError}
                                                </Segment>
                                            </Grid.Column>
                                        ) : (
                                                <div></div>
                                            )
                                    } */}
                  {this.state.response ? (
                    this.state.response.code === 200 ? (
                      <Modal
                        id="registerMain"
                        style={{ width: "390px" }}
                        observeChanges="true"
                        size="mini"
                        open={this.state.modalOpen}
                      >
                        <Modal.Content style={{ padding: "0" }}>
                          <Grid
                            textAlign="center"
                            style={{ height: "100%" }}
                            verticalAlign="middle"
                          >
                            <Grid.Column style={{ maxWidth: "390px" }}>
                              <Image
                                onClick={this.handleCloseRenameSecond}
                                src={Exit}
                                centered
                                floated="right"
                                id="exit"
                              />
                              <Header
                                as="h2"
                                id="modalRegisterHeader"
                                textAlign="center"
                              >
                                {t("welcome")}
                              </Header>

                              <Grid
                                textAlign="center"
                                style={{ height: "100%", margin: "0px" }}
                                verticalAlign="middle"
                              >
                                <Grid.Column
                                  textAlign={"center"}
                                  verticalAlign={"middle"}
                                >
                                  {/* La source étant un bool, cela faisait crash le site, que devait être la source ?
                                                                    <Image centered src={check} style={{ width: "50px" }} />*/}
                                  {/* <Image src={EmailSend} id="emailSendIcon"/> */}
                                  <Header as="h5" id="account">
                                    {t("confirm")}
                                  </Header>
                                </Grid.Column>
                              </Grid>
                            </Grid.Column>
                          </Grid>
                        </Modal.Content>

                        <Modal.Actions style={{ textAlign: "center" }}>
                          <Button
                            color="red"
                            size="medium"
                            style={{ fontFamily: "MavenProBold" }}
                            onClick={this.openLogin}
                          >
                            {t("register_connect")}
                          </Button>
                        </Modal.Actions>
                      </Modal>
                    ) : this.state.response.code === 302 ? (
                      <Grid.Column style={{ paddingBottom: "15px" }}>
                        <Segment
                          inverted
                          color="red"
                          tertiary
                          style={errorMessageRegister}
                        >
                          <Icon name={"remove circle"} />
                          {t("error_mail")}
                        </Segment>
                      </Grid.Column>
                    ) : (
                      <div />
                    )
                  ) : (
                    <div />
                  )}

                  <Message
                    error
                    header="Erreur"
                    content="Merci de vérifier que tous les champs sont renseignés"
                  />
                  <Button
                    fluid
                    size="large"
                    color="yellow"
                    className="buttonSubmit"
                    onClick={() => this.sendUser()}
                  >
                    {t("register_signin")}
                  </Button>
                </Form>

                <Header as="h5" id="account">
                  {t("already_account")}
                  <a
                    onClick={this.openLogin}
                    id="modalRegisterLink"
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    <u>{t("register_connect")}</u>
                  </a>
                </Header>
              </Grid.Column>
            </Grid>
          </Modal.Content>
        </div>
      </Modal>
    );
  }
}

const RegisterComponent = connect(
  mapStateToProps,
  mapActionToProps
)(ConnectedRegisterComponent);
export default translate("RegisterComponent")(RegisterComponent);



// WEBPACK FOOTER //
// ./src/components/Login/Register.jsx